module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71281/img/DeepL-logo.png"